/**
 * Persiste o GRUPO FAMILIAR escolhido, para a seleção sobreviver ao reload.
 *
 * Espelha o que o consolidador já faz com o cliente selecionado
 * (`state/modules/user/mutations.js` — `ADD_LIST_SEARCH_CLIENT` /
 * `restoreSearchClientsFromStorage`): chave por usuário, escrita no momento da
 * escolha, leitura no boot da tela.
 *
 * Guarda só o ID. O objeto do grupo vem da listagem a cada carga — persistir o
 * objeto inteiro deixaria nome e contagem de membros congelados em disco,
 * divergindo do backend depois de qualquer edição.
 *
 * Toda escrita é envolvida em `try/catch` sem tratamento: storage cheio, modo privado ou bloqueado
 * por política do navegador não podem derrubar a tela, e a persistência é conveniência — a seleção
 * continua valendo na sessão, só não sobrevive ao reload.
 */
const PREFIXO = 'az_gf_sel_'
const PREFIXO_MODO = 'az_gf_modo_'

const chave = (idUsuario) => `${PREFIXO}${idUsuario || 'anon'}`
const chaveModo = (idUsuario) => `${PREFIXO_MODO}${idUsuario || 'anon'}`

const temStorage = () => {
  try {
    return typeof globalThis !== 'undefined' && !!globalThis.localStorage
  } catch {
    return false
  }
}

/**
 * @param {String|Number} idUsuario
 * @returns {String} ID do grupo salvo, ou string vazia.
 */
export const readSelectedGroupId = (idUsuario) => {
  if (!temStorage()) return ''
  try {
    return globalThis.localStorage.getItem(chave(idUsuario)) || ''
  } catch {
    return ''
  }
}

/**
 * @param {String|Number} idUsuario
 * @param {String|Number} idGrupo Passar vazio/nulo limpa a seleção.
 */
export const writeSelectedGroupId = (idUsuario, idGrupo) => {
  if (!temStorage()) return
  try {
    if (!idGrupo) {
      globalThis.localStorage.removeItem(chave(idUsuario))
      return
    }
    globalThis.localStorage.setItem(chave(idUsuario), String(idGrupo))
  } catch {
    // eslint-disable-next-line no-empty
  }
}

/**
 * @param {String|Number} idUsuario
 * @returns {String} modo do seletor salvo, ou string vazia.
 */
export const readSelectedMode = (idUsuario) => {
  if (!temStorage()) return ''
  try {
    return globalThis.localStorage.getItem(chaveModo(idUsuario)) || ''
  } catch {
    return ''
  }
}

/**
 * @param {String|Number} idUsuario
 * @param {String} modo Passar vazio/nulo limpa.
 */
export const writeSelectedMode = (idUsuario, modo) => {
  if (!temStorage()) return
  try {
    if (!modo) {
      globalThis.localStorage.removeItem(chaveModo(idUsuario))
      return
    }
    globalThis.localStorage.setItem(chaveModo(idUsuario), String(modo))
  } catch {
    // eslint-disable-next-line no-empty
  }
}
